
import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Table } from 'react-bootstrap';

export default function SeriiModal({ show, onHide, line, onSave, readOnly }) {
    const [serii, setSerii] = useState([]);
    const qty = Number(line?.bxqty || 0);

    useEffect(() => {
        if (show) {
            let initialSerii = line?.serii || [];
            if (!readOnly && initialSerii.length < qty) {
                // Fill with empty strings to match qty
                initialSerii = [...initialSerii, ...Array(qty - initialSerii.length).fill('')];
            } else if (!readOnly && initialSerii.length > qty) {
                // Truncate if qty was reduced
                initialSerii = initialSerii.slice(0, qty);
            }
            setSerii(initialSerii);
        }
    }, [show, line, qty, readOnly]);

    const handleChange = (idx, value) => {
        const noSpace = value.trim();
        const newSerii = [...serii];
        newSerii[idx] = noSpace;
        setSerii(newSerii);
    };

    const handleSave = () => {
        onSave(serii);
        onHide();
    };

    const isComplete = serii.length === qty && serii.every(s => s.trim() !== '');

    return (
        <Modal show={show} onHide={onHide}>
            <Modal.Header closeButton>
                <Modal.Title>Serii Articole (Total: {qty})</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Table bordered size="sm">
                    <thead>
                        <tr>
                            <th width="50">#</th>
                            <th>Serie</th>
                        </tr>
                    </thead>
                    <tbody>
                        {serii.map((s, idx) => (
                            <tr key={idx}>
                                <td>{idx + 1}</td>
                                <td>
                                    {readOnly ? (
                                        <span>{s}</span>
                                    ) : (
                                        <Form.Control
                                            type="text"
                                            size="sm"
                                            value={s}
                                            onChange={e => handleChange(idx, e.target.value)}
                                            placeholder="Introdu seria..."
                                            autoFocus={idx === 0}
                                        />
                                    )}
                                </td>
                            </tr>
                        ))}
                        {serii.length === 0 && (
                            <tr><td colSpan={2} className="text-center text-muted">Nicio serie (Cantitate = 0)</td></tr>
                        )}
                    </tbody>
                </Table>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>Inchide</Button>
                {!readOnly && (
                    <Button variant="primary" onClick={handleSave} disabled={!isComplete}>
                        Salveaza
                    </Button>
                )}
            </Modal.Footer>
        </Modal>
    );
}

